import React from 'react';
import { t, defineMessages } from '@sm/intl';
import solutionsImage from '../assets/CTM_MasterScorecard.png';
import SummarySideBar from '../SummarySideBar';
import { SolutionsSummarySideBarEnums } from '../SummarySideBarEnums';
import '../summary-side-bar.scss';

const DEFAULT_COPY = defineMessages({
  HEADLINE: {
    id: 'SolutionsSummarySideBar.headline',
    defaultMessage: 'Did you know?',
    description:
      '[Type: Header][Vis.: low] - Survey summary marketing sidebar headline',
  },
  MESSAGE: {
    id: 'SolutionsSummarySideBar.message',
    defaultMessage:
      "SurveyMonkey's market research solutions incorporate guided methodologies and AI-Powered Insights to uncover meaningful trends, fast.",
    description:
      '[Type: Paragraph][Vis.: low] - Survey summary marketing sidebar message',
  },
  CTA_TEXT: {
    id: 'SolutionsSummarySideBar.ctaText',
    defaultMessage: 'VIEW ALL SOLUTIONS',
    description:
      '[Type: Button][Vis.: low] - Survey summary marketing sidebar CTA button',
  },
});

const GET_A_DEMO_COPY = defineMessages({
  HEADLINE: {
    id: 'SolutionsSummarySideBar.demoHeadline',
    defaultMessage: 'Did you know?',
    description:
      '[Type: Header][Vis.: low] - Survey summary marketing sidebar headline',
  },
  MESSAGE: {
    id: 'SolutionsSummarySideBar.demoMessage',
    defaultMessage:
      "SurveyMonkey's market research solutions incorporate guided methodologies and AI-Powered Insights to uncover meaningful trends, fast.",
    description:
      '[Type: Paragraph][Vis.: low] - Survey summary marketing sidebar message',
  },
  CTA_TEXT: {
    id: 'SolutionsSummarySideBar.demoCtaText',
    defaultMessage: 'Get a demo',
    description:
      '[Type: Button][Vis.: low] - Survey summary marketing sidebar CTA button',
  },
});

export type SolutionsSummarySideBarProps = {
  variation?: SolutionsSummarySideBarEnums | null;
};

const VariationToCopy = {
  [SolutionsSummarySideBarEnums.BlueThemedContactUsPageRedirect]: GET_A_DEMO_COPY,
  [SolutionsSummarySideBarEnums.DarkThemedContactUsPageRedirect]: GET_A_DEMO_COPY,
  [SolutionsSummarySideBarEnums.Default]: DEFAULT_COPY,
};

const VariationToCTARedirect = {
  [SolutionsSummarySideBarEnums.BlueThemedContactUsPageRedirect]:
    '/market-research/get-a-demo/',
  [SolutionsSummarySideBarEnums.DarkThemedContactUsPageRedirect]:
    'https://www.momentive.ai/en/contact/',
  [SolutionsSummarySideBarEnums.Default]:
    '/market-research/solutions/?ut_source=survey_summary',
};

export const SolutionsSummarySideBar: React.FC<SolutionsSummarySideBarProps> = ({
  variation,
}) => {
  const copy =
    variation && variation in VariationToCopy
      ? VariationToCopy[variation]
      : DEFAULT_COPY;

  const CTARedirect =
    variation && variation in VariationToCTARedirect
      ? VariationToCTARedirect[variation]
      : '/market-research/solutions/?ut_source=survey_summary';
  return (
    <SummarySideBar
      headline={t(copy.HEADLINE)}
      message={t(copy.MESSAGE)}
      image={() => (
        <img
          src={solutionsImage}
          className="sm-summary-side-bar__image"
          height="auto"
          alt=""
        />
      )}
      ctaText={t(copy.CTA_TEXT)}
      ctaLink={CTARedirect}
    />
  );
};

export default SolutionsSummarySideBar;
